import { doc, getDoc } from 'firebase/firestore';

import { firestore } from 'services/firebase/client';
import { normalizeGrowlersCartRules } from 'utils/growlersCartPricing';
import {
  DEFAULT_GROWLERS_CART_RULES,
  GROWLERS_CART_RULES_DOC_ID,
  type GrowlersCartRules,
} from 'utils/types/GrowlersCartRules';

/**
 * Regras do carrinho de /growlers.
 * Firestore: site_config/growlers_cart_rules
 */
export async function getGrowlersCartRules(): Promise<GrowlersCartRules> {
  try {
    const ref = doc(firestore, 'site_config', GROWLERS_CART_RULES_DOC_ID);
    const snapshot = await getDoc(ref);
    if (!snapshot.exists()) {
      return DEFAULT_GROWLERS_CART_RULES;
    }
    return normalizeGrowlersCartRules(snapshot.data());
  } catch (error) {
    console.error('Erro ao buscar regras do carrinho de growlers:', error);
    return DEFAULT_GROWLERS_CART_RULES;
  }
}
